import { render, staticRenderFns } from "./relevanceDevicesDialog.vue?vue&type=template&id=e9cfe638&scoped=true"
import script from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"
export * from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cfe638",
  null
  
)

export default component.exports